/* eslint-disable */
// This file is generated from GraphQL mutation @permission directives. Do not edit directly.

export const mutationPermissionRequirements = {
	"addInvestingEntityDocuments": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"completeBeneficialOwnerContactDetails": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"confirmAccreditation": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"createAllocationRequest": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"createBankAccount": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"placeBuyOrder": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"placeSellOrder": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"provideSourceOfFunds": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"recordApplicationStarted": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"requestUnitRedemption": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"updateBankAccount": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"updateCompanyInvestingEntity": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"updateFatcaCRS": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"updateHolding": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"updateIndividualInvestingEntity": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"updateInvestingEntityDefaultBankAccount": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"updateInvestingEntityHoldingBankAccount": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"updateJointIndividualInvestingEntity": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"updatePartnershipInvestingEntity": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"updateTrustInvestingEntity": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"uploadBankAccountVerificationDocument": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"uploadCustomFieldDocument": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	],
	"uploadInvestingEntityDocuments": [
		{
			"resource": "investing_entity",
			"requires": "investing_entity:update"
		}
	]
} as const;

export type PermissionedMutation = keyof typeof mutationPermissionRequirements;
export type PermissionRequirement = (typeof mutationPermissionRequirements)[PermissionedMutation][number];
